export default __webpack_public_path__ + "static/media/cert2.dd001a23.png";